


const api_key = "813ac72085badf12a9f36cfdbe3c5f2a2a74e05e7bcb6a118cf14804547d0b20"

module.exports = api_key